import { Card } from '@fl/cmsch-fe-library';
import React, { FC, memo, useMemo } from 'react';
import { Content } from 'app/content';
import { useOurTranslation } from 'app/translations';
import { ConnectedScreenHeader } from 'common/layout';
import { PermissionsTable } from '../components/permission-table';
const PermissionsBase: FC = () => {
  const {
    t
  } = useOurTranslation('admin');
  const title = t('permissions');
  const header = useMemo(() => <ConnectedScreenHeader title={title} />, [title]);
  return <Content browserTabTitle={title} data-sentry-element="Content" data-sentry-component="PermissionsBase" data-sentry-source-file="permissions.tsx">
            <Card title={header} titleSize="medium" noWhiteSpaceBody data-sentry-element="Card" data-sentry-source-file="permissions.tsx">
                <PermissionsTable data-sentry-element="PermissionsTable" data-sentry-source-file="permissions.tsx" />
            </Card>
        </Content>;
};

/** Admin permissions screen. */
export const Permissions = memo(PermissionsBase);